import React from 'react';
import AdministratorHeaderView from './components/header/AdministratorHeaderView';
import AdminBodyView from './components/body/AdministratorBodyView';
import Processing from '@/presentation/components/Processing';
import Modal from '../procedures/components/Modal/Modal';
import NotEnrolledInfo from '../default/NotEnrolledPage/NotEnrolledInfo';

interface AdminViewProps {
  handleActiveSimulate: (studentCode: any) => void;
  error: any;
  handleInputChange: (code: any) => void;
  disabled: boolean;
  isLoading: boolean;
  handleLogOut: () => void;
  modalNotEnrolled: boolean;
  setModalNotEnrolled: (e: boolean) => void;
}

const AdministratorView = (props: AdminViewProps) => {
  const {
    handleActiveSimulate,
    error,
    handleInputChange,
    disabled,
    isLoading,
    handleLogOut,
    modalNotEnrolled,
    setModalNotEnrolled
  } = props;

  return (
    <div data-testid="cmp-administrator-view">
      <AdministratorHeaderView handleLogOut={handleLogOut} />
      <Processing isOpen={isLoading} />
      <AdminBodyView
        handleActiveSimulate={handleActiveSimulate}
        error={error}
        handleInputChange={handleInputChange}
        disabled={disabled}
      />
      <Modal
        show={modalNotEnrolled}
        handleClose={() => {
          setModalNotEnrolled(false);
        }}
      >
        <div style={{ margin: '16px 0px 16px 16px' }}>
          <NotEnrolledInfo isAdmin />
        </div>
      </Modal>
    </div>
  );
};

export default AdministratorView;
